export default __webpack_public_path__ + "static/media/logo-dart-beta.010256f9.png";